import React from 'react';
import PropTypes from 'prop-types';

import { USD } from 'helpers/formatters/number_formats';

import './styles.scss';

export function TiersTable({ royaltySchedule }) {
  return (
    <div className="royalty-settings">
      <table className="table tiers-table">
        <thead>
          <tr>
            <th>Tier</th>
            <th className="text-right">From</th>
            <th className="text-right">To</th>
            <th className="text-right">Royalty %</th>
          </tr>
        </thead>

        <tbody>
          {royaltySchedule.tiers.map((tier, index) => (
            <tr key={index}>
              <td>Tier {index + 1}</td>
              <td className="text-right">{USD.format(tier.from, { round: true })}</td>
              <td className="text-right">
                {tier.to ? USD.format(tier.to, { round: true }) : 'Unlimited'}
              </td>
              <td className="text-right">
                <strong>{tier.royaltyPercentage} %</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

TiersTable.propTypes = {
  royaltySchedule: PropTypes.shape({
    tiers: PropTypes.array.isRequired,
  }).isRequired,
};

export default TiersTable;
